export function setLoading(state, value) {
  state.loading = !!value
}

export function setError(state, error) {
  state.error = error || null
}

export function setSubmembers(state, payload) {
  const list = Array.isArray(payload?.members) ? payload.members : []
  state.submembers = list
  state.totalDocs = payload?.totalDocs ?? list.length
  state.totalPages = payload?.totalPages ?? 0
  state.page = Number(payload?.page) || 1
  state.totalSubmembers = payload?.totalSubmembers ?? list.length
}

export function upsertSubmember(state, submember) {
  if (!submember || !submember._id) return
  const list = state.submembers || []
  const idx = list.findIndex((s) => String(s._id) === String(submember._id))
  if (idx >= 0) {
    const next = [...list]
    next[idx] = { ...next[idx], ...submember }
    state.submembers = next
  } else {
    state.submembers = [submember, ...list]
    state.totalDocs = (state.totalDocs || 0) + 1
    state.totalSubmembers = (state.totalSubmembers || 0) + 1
  }
}

export function clearSubmembers(state) {
  state.submembers = []
  state.totalDocs = 0
  state.totalPages = 0
  state.page = 1
  state.totalSubmembers = 0
  state.error = null
}
